/*
 * NEXZ — editorial collection reveal fallback. Where the browser has
 * scroll-driven animations, nexz-editorial.css animates everything and
 * this does nothing. Elsewhere it adds .is-in to each banner once it's
 * on screen, for a one-time fade/rise. Reduced motion: CSS shows all.
 */
if (!CSS.supports('animation-timeline: view()') && 'IntersectionObserver' in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      }
    },
    { threshold: 0.15 }
  );
  document.querySelectorAll('.nxe-b').forEach((banner) => observer.observe(banner));
}
